module.exports = __webpack_public_path__ + "static/img/hosoda_05.f72c828.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/hosoda_05.png
// module id = 0gTk
// module chunks = 0